import { useEffect, useState } from 'react';
import Joi from 'joi';
import { Link, Redirect } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import Logo from '../../../images/mg_logo.png';
import useForm from '../../../hooks/useForm';
import { renderInput, renderButton } from '../../common/renderUtils';
import auth from '../../../services/authService';
import { setDocTitle } from '../../../utils/utilities';
import i18n from '../../../i18n';

const SignIn = (props) => {
  const { t } = useTranslation();
  const [signingIn, setSigningIn] = useState(false);

  const schema = {
    email: Joi.string().required().email({ tlds: { allow: false } }).label('Email Address'),
    password: Joi.string().required().label('Password'),
  };

  const initialData = { email: '', password: '' };

  const { data, errors, setErrors, handleChange, handleSubmit, isFormValid } = useForm(initialData, schema);

  useEffect(() => {
    setDocTitle(t('auth.signIn'));
  }, [t]);

  const doSubmit = async () => {
    try {
      setSigningIn(true);

      await auth.signin(data.email, data.password);

      // Redirect the user to where they came from
      const { state } = props.location;

      window.location = state ? state.from.pathname : '/';
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const newErrors = { ...errors };
        newErrors.email = signInError(ex.response.data);
        setErrors(newErrors);
      }
      setSigningIn(false);
    }
  };

  // if there is a user, redirect it to homepage
  if (auth.getCurrentUser()) return <Redirect to="/songs" />;

  return (
    <div className="auth-page">
      <form onSubmit={(e) => handleSubmit(e, doSubmit)} className="form-signin">
        <Link to="/">
          <img src={Logo} alt={t('nav.logoAlt')} className="form-logo" />
        </Link>

        {renderInput('email', t('auth.email'), 'email', data, errors, handleChange)}
        {renderInput('password', t('auth.password'), 'password', data, errors, handleChange)}
        <Link to="/resetpassword">
          <small className="mg-d-block mg-text-right forgot-password">{t('auth.forgotPassword')}</small>
        </Link>
        {renderButton(t('auth.signIn'), isFormValid(), signingIn)}

        <div className="mg-text-center mg-mt-2">
          <Trans i18nKey="auth.orCreateAccount" components={{ go: <Link to="/signup" /> }} />
        </div>
      </form>
    </div>
  );
};

// The backend's wrong-login text is shown in the app's language; anything else as it came
const signInError = (message) => (message === 'Invalid email or password.' ? i18n.t('auth.invalidLogin') : message);

export default SignIn;
